import DocumentGroupHelperServices from "../../Reducers/DocumentGroups/DocumentGroupResponseHelper";
import * as actions from "../../ActionType/UserActionType";
const dispatchAction:any=(dispatch:any ,actionType:any, data:any,  error:string, message:string)=>{
    dispatch({type:actionType,payload:data, message:message});
};

class DocumentGroupServices{
    createDocumentGroup=(userParam:any,accessToken:string,enqueueSnackbar:any)=>async (dispatch:any )=>{
        try{
            const createGroups = await DocumentGroupHelperServices.CREATE_DOCUMENTS_GROUP(userParam,accessToken);
            if(createGroups?.name){
                dispatchAction(dispatch, actions?.CREATE_DOCUMENT_GROUP, createGroups)
                enqueueSnackbar('Success!', { variant: 'success' });
            }else{
                dispatchAction(dispatch,actions?.CREATE_DOCUMENT_GROUP, createGroups, [], 'Invalid userGroup !')
                enqueueSnackbar(createGroups?.error?.message, { variant: 'error' });
            }
           }catch(error){console.log('create user group error  ==>',error)}
    }
    allDocumentGroups=(customerId:number, accessToken:string)=>async (dispatch:any )=>{
        try{
            const getAllGroups = await DocumentGroupHelperServices.ALL_DOCUMENTS_GROUP(customerId, accessToken);
            if(getAllGroups){
                dispatchAction(dispatch, actions?.ALL_DOCUMENTS_GROUP, getAllGroups)
            }else{
                dispatchAction(dispatch,actions?.ALL_DOCUMENTS_GROUP, getAllGroups, [], 'Invalid documentGroup !')
            }
           }catch(error){console.log('all get documents group error  ==>',error)}
    }
    deleteDocumentsGroup=(groupId:any,accessToken:string)=>async (dispatch:any )=>{
        try{
            const deleteGroups = await DocumentGroupHelperServices.DELETE_DOCUMENTS_GROUP(groupId,accessToken);
            if(deleteGroups){
                dispatchAction(dispatch, actions?.DELETE_DOCUMENT_GROUP, deleteGroups)
            }else{
                dispatchAction(dispatch,actions?.DELETE_DOCUMENT_GROUP, deleteGroups, [], 'Invalid delete documentGroup !')
            }
           }catch(error){console.log('delete documents group error  ==>',error)}
    }
    getByIdDocumentsGroup=(groupId:any,accessToken:string)=>async (dispatch:any )=>{
        try{
            const idByGroups = await DocumentGroupHelperServices.GET_ID_BY_DOCUMENTS_GROUP(groupId,accessToken);
            if(idByGroups){
                dispatchAction(dispatch, actions?.GET_DOCUMENT_GROUP_BYID , idByGroups)
            }else{
                dispatchAction(dispatch,actions?.GET_DOCUMENT_GROUP_BYID , idByGroups, [], 'Invalid id By documentGroup !')
            }
           }catch(error){console.log('get id by documents group error  ==>',error)}
    }
    assignDocumentsGroup = (userGroup:any,accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=> {
        try{
         const formDocumentsGroups = await DocumentGroupHelperServices.ASSIGN_GROUP_ADD_DOCUMENT(userGroup,accessToken);
         if(formDocumentsGroups){
             dispatchAction(dispatch, actions?.ADD_DOCUMENT_FORM_GROUP, formDocumentsGroups)
             enqueueSnackbar('Success!', { variant: 'success' });
         }else{
             dispatchAction(dispatch,actions?.ADD_DOCUMENT_FORM_GROUP, formDocumentsGroups, [], 'Invalid form documentGroup !')
             enqueueSnackbar(formDocumentsGroups?.error?.message, { variant: 'error' });
         }
        }catch(error){console.log('form document group error  ==>',error)}
     };
     permissionGroup = (permission:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const groups = await DocumentGroupHelperServices.PERMISSION_GROUP(permission,accessToken);
         if(groups){
             dispatchAction(dispatch, actions?.ADD_PERMISSION, groups)
         }else{
             dispatchAction(dispatch,actions?.ADD_PERMISSION, groups, [], 'Invalid permissionGroup !')
         }
        }catch(error){console.log('permission group error  ==>',error)}
     };
     documentGroupPermission = (permission:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const groupsPermission = await DocumentGroupHelperServices.GROUP_DOCUMENT_PERMISSION(permission,accessToken);
         if(groupsPermission){
             dispatchAction(dispatch, actions?.DOCUMENT_GROUP_PERMISSION, groupsPermission)
         }else{
             dispatchAction(dispatch,actions?.DOCUMENT_GROUP_PERMISSION, groupsPermission, [], 'Invalid permission Document Group !')
         }
        }catch(error){console.log('permission document group error  ==>',error)}
     };
     userDeletePermission = (permissionId:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const deleteUserPermission = await DocumentGroupHelperServices.DELETE_PERMISSION_USER(permissionId,accessToken);
         if(deleteUserPermission){
             dispatchAction(dispatch, actions?.USER_DELETE_PERMISSION, deleteUserPermission)
         }else{
             dispatchAction(dispatch,actions?.USER_DELETE_PERMISSION, deleteUserPermission, [], 'Invalid permission delete  Document user !')
         }
        }catch(error){console.log('permission delete  Document user error  ==>',error)}
     };
     userGroupDeletePermission = (permissionId:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const userGroupsPermissionDelete = await DocumentGroupHelperServices.DELETE_PERMISSION_USER_GROUP(permissionId,accessToken);
         if(userGroupsPermissionDelete){
             dispatchAction(dispatch, actions?.USER_GROUP_DELETE_PERMISSION, userGroupsPermissionDelete)
         }else{
             dispatchAction(dispatch,actions?.USER_GROUP_DELETE_PERMISSION, userGroupsPermissionDelete, [], 'Invalid permission Document User Group delete!')
         }
        }catch(error){console.log('permission Document User Group delete error  ==>',error)}
     };
     updateDocumentGroup = (groupParam:any,documentGroupId:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const updateGroups = await DocumentGroupHelperServices.UPDATE_DOCUMENTS_GROUP(groupParam,documentGroupId,accessToken);
         if(updateGroups){
             dispatchAction(dispatch, actions?.UPDATE_DOCUMENT_GROUP, updateGroups)
         }else{
             dispatchAction(dispatch,actions?.UPDATE_DOCUMENT_GROUP, updateGroups, [], 'Invalid documentGroup !')
         }
        }catch(error){console.log('update document group error  ==>',error)}
     };
     documentHierarchical = (customerId:any,accessToken:any) =>async (dispatch:any )=> {
        try{
         const documentGroups = await DocumentGroupHelperServices.HIERARCHICAL_DOCUMENTS_GROUP(customerId,accessToken);
         if(documentGroups){
             dispatchAction(dispatch, actions?.TREE_STRUCTURE_LIST_DOCUMENT_GROUP, documentGroups)
         }else{
             dispatchAction(dispatch,actions?.TREE_STRUCTURE_LIST_DOCUMENT_GROUP, documentGroups, [], 'Invalid documentGroup !')
         }
        }catch(error){console.log('update document group error  ==>',error)}
     };
}
export default new DocumentGroupServices();